import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { api, money, formatApiError } from "../api";
import { useAuth } from "../context/AuthContext";

export default function Account() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [pwd, setPwd] = useState({ current_password: "", new_password: "" });
  const [showPwd, setShowPwd] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/api/orders/mine");
        setOrders(data);
      } catch {
        setOrders([]);
      }
    })();
  }, []);

  const changePassword = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/auth/change-password", pwd);
      toast.success("Password updated");
      setPwd({ current_password: "", new_password: "" });
      setShowPwd(false);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <main className="page" data-testid="account-page">
      <div className="page-head">
        <span className="eyebrow">Your house account</span>
        <h1>
          Welcome, <em>{user?.name?.split(" ")[0]}.</em>
        </h1>
        <p data-testid="account-welcome">Signed in as {user?.email}</p>
      </div>

      <section style={{ maxWidth: 720 }}>
        <h2 style={{ fontSize: 28, marginBottom: 24 }}>My orders</h2>
        {orders.length ? (
          <div>
            {orders.map((o) => (
              <div key={o.id} style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr auto", gap: 20, alignItems: "center", padding: "18px 0", borderTop: "1px solid var(--line-soft)" }} data-testid={`account-order-${o.order_id}`}>
                <div>
                  <strong style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 400 }}>{o.order_id}</strong>
                  <br />
                  <span className="eyebrow" style={{ fontSize: 10, marginTop: 4 }}>
                    {new Date(o.created_at).toLocaleDateString()}
                  </span>
                </div>
                <span style={{ color: "var(--wine)", fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase" }}>{o.status}</span>
                <strong style={{ fontFamily: "'Jost',sans-serif", fontSize: 14 }}>{money(o.total)}</strong>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: "var(--muted)" }}>Your orders will appear here after your first WhatsApp handoff.</p>
        )}
      </section>

      <section style={{ marginTop: 60, maxWidth: 520 }}>
        <button className="btn btn-outline" onClick={() => setShowPwd(!showPwd)} data-testid="toggle-change-password">
          {showPwd ? "Cancel" : "Change password"}
        </button>
        {showPwd && (
          <form onSubmit={changePassword} className="checkout-form" style={{ marginTop: 24 }}>
            <div className="form-field">
              <label>Current password</label>
              <input required type="password" value={pwd.current_password} onChange={(e) => setPwd({ ...pwd, current_password: e.target.value })} data-testid="current-password-input" />
            </div>
            <div className="form-field">
              <label>New password</label>
              <input required type="password" minLength={6} value={pwd.new_password} onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })} data-testid="new-password-input" />
            </div>
            <button className="btn btn-primary" type="submit" data-testid="change-password-submit">
              Update password <ArrowUpRight size={14} />
            </button>
          </form>
        )}
        <button className="btn btn-outline" onClick={handleLogout} data-testid="sign-out-button" style={{ marginTop: 20 }}>
          Sign out
        </button>
      </section>
    </main>
  );
}
